/**
 * M148 — the owner's DRIBBLE RACER logo art (public/brand/title-logo.webp;
 * the WORLD TOUR CUP line is part of the image) with a light metallic shine
 * that travels ALONG the gold-and-green swoops.
 *
 * How the shine works: an overlay layer is masked to the swoops alone
 * (public/brand/title-logo-swoop.webp — its alpha is the swoop pixels only,
 * so the letters, the ball and the cup line never catch it). Inside it a
 * soft warm-white band slides left to right — from the swoop's tail tip,
 * under RACER, to the ball — then rests a few seconds. A pure CSS transform,
 * so it runs on the compositor and works back to iOS 15. Reduced motion (the
 * setting's `.reduced` class on a screen root, or the OS query) parks it.
 *
 * One builder for every surface that shows the logo. Size it with a CSS
 * width on the returned element; the height follows (the box keeps the art's
 * aspect). Both files are swappable drop-ins: a new logo needs its swoop
 * mask re-cut to the same canvas (`python3 scripts/brand-logo-mask.py`).
 */
import { el } from './dom';

export interface BrandLogoOptions {
  /** The travelling shine on the swoops (default true). */
  shine?: boolean;
  /** The 720 px file, for small placements (under ~360 CSS px wide). */
  small?: boolean;
}

export function brandLogo(
  parent: HTMLElement,
  className = '',
  opts: BrandLogoOptions = {},
): HTMLElement {
  const base = import.meta.env.BASE_URL;
  const box = el('div', className ? `brand-logo ${className}` : 'brand-logo', parent);
  const img = el('img', 'brand-logo-img', box);
  img.src = `${base}brand/${opts.small ? 'title-logo-sm' : 'title-logo'}.webp`;
  img.alt = 'Dribble Racer · World Tour Cup';
  img.decoding = 'async';
  img.draggable = false;
  if (opts.shine !== false) {
    const shine = el('div', 'brand-logo-shine', box);
    shine.setAttribute('aria-hidden', 'true');
    const mask = `url("${base}brand/title-logo-swoop.webp")`;
    shine.style.setProperty('-webkit-mask-image', mask);
    shine.style.setProperty('mask-image', mask);
    el('div', 'brand-logo-glint', shine);
  }
  return box;
}
